import { Fragment } from 'react';

import useOrgUnitAdminMeetInfo from './UseOrgUnitAdminMeetInfo';

import Views from '../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import OrgUnitAdminContactsWrite from './orgUnitAdminContacts/OrgUnitAdminContactsWrite';
import OrgUnitAdminContactsReadOnly from './orgUnitAdminContacts/OrgUnitAdminContactsReadOnly'

import Headings from '@usas/ui-web/components/headings/Headings';
import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';
import DateTimePicker from '@usas/ui-web/components/datepickers/DateTimePicker';
import ToolTip from '@usas/ui-web/components/tooltips/ToolTip';
import ReadOnly from '@usas/ui-web/components/readOnly/ReadOnly';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';

import Constants from '@usas/ui-web/utils/Constants';
import { formatDateTimeTwelveHourClock } from '@usas/ui-web/utils/DateFunctions';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OrgUnitAdminMeetInfo = () => {
  const { state, modalState, oUAdminEntryContextState, omeMeetOrgUnitEntryState, omeMeetOrgUnitEntryInfoState, omeMeetOrgUnitAthleteEntryState, omeMeetOrgUnitAthleteEntryRelayRosterEntryState,
    omeMeetOrgUnitNonAthleteEntryState, omeMeetOrgUnitContactState, omeMeetOrgUnitEntryRosterPermissionsState, dateTimeState, formState, errorState, handleSubmit, onFormValueChanged,
    onNextButtonClicked, onSaveAndExitButtonClicked, onAddContact, onEditContact, onDeleteContactClicked, onDeleteContact, onModalCanceled } = useOrgUnitAdminMeetInfo();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_INFO_TEAM_ENTRY}
        onNextButtonClicked={onNextButtonClicked}
        onSaveAndExitButtonClicked={onSaveAndExitButtonClicked}
        errorMessage={errorState.error}
      >
        {state.initialLoadComplete === true &&
          <Fragment>
            {oUAdminEntryContextState.isReadOnly === false ?
              <Fragment>
                <div className="row">
                  <div className="col-xs-12">
                    <Headings.H5>Roster Permissions</Headings.H5>
                  </div>
                </div>
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-xs-12">
                      <YesNoSwitch
                        label="Allow athletes (and their guardians) to enter themselves into the meet?"
                        name="orgUnitAthleteRegistrationAllowed"
                        checked={formState.orgUnitAthleteRegistrationAllowed}
                        error={errorState.orgUnitAthleteRegistrationAllowed}
                        message={errorState.orgUnitAthleteRegistrationAllowed}
                        onChange={(value) => { onFormValueChanged('orgUnitAthleteRegistrationAllowed', value) }} />
                    </div>
                    <div className={formState.orgUnitAthleteRegistrationAllowed === true ? global.DisplayComponent : global.HideComponent}>
                      <div className="col-xs-12 col-sm-6">
                        <DateTimePicker
                          label={<Fragment>Athlete Entry Start Date* <span><ToolTip label="Date and time when the team's athletes (and their guardians) can begin to submit their entry"></ToolTip></span></Fragment>}
                          name="orgUnitRegistrationStartDate"
                          value={formState.orgUnitRegistrationStartDate}
                          error={errorState.orgUnitRegistrationStartDate}
                          message={errorState.orgUnitRegistrationStartDate}
                          onChange={(value) => { onFormValueChanged('orgUnitRegistrationStartDate', value); }}
                          countOfYears={5}
                          startYearOffset={0} />
                      </div>
                      <div className="col-xs-12 col-sm-6">
                        <DateTimePicker
                          label={<Fragment>Athlete Entry End Date* <span><ToolTip label="Deadline for the team's athletes (and their guardians) to submit their entry"></ToolTip></span></Fragment>}
                          name="orgUnitRegistrationEndDate"
                          value={formState.orgUnitRegistrationEndDate}
                          error={errorState.orgUnitRegistrationEndDate}
                          message={errorState.orgUnitRegistrationEndDate}
                          onChange={(value) => { onFormValueChanged('orgUnitRegistrationEndDate', value); }}
                          countOfYears={5}
                          startYearOffset={0} />
                      </div>
                      <div className="col-xs-12 col-md-6">
                        <ReadOnly
                          label={<Fragment>Time Zone <span><ToolTip label="Time Zone for the Athlete Entry Start Date and Athlete Entry End Date"></ToolTip></span></Fragment>}
                          name="timeZone"
                          value={formState.timeZone} />
                      </div>
                    </div>
                  </div>
                </form>
                <div className="row usas-extra-top-margin">
                  <div className="col-xs-12">
                    <OrgUnitAdminContactsWrite onAddContact={onAddContact} onEditContact={onEditContact} onDeleteContactClicked={onDeleteContactClicked} omeMeetOrgUnitContactState={omeMeetOrgUnitContactState} />
                  </div>
                </div>
              </Fragment>
              :
              <Fragment>
                <div className="row">
                  <div className="col-xs-12">
                    <Headings.H5>Roster Permissions</Headings.H5>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-12">
                    <YesNoSwitch
                      label="Allow athletes (and their guardians) to enter themselves into the meet?"
                      name="rosterEntryAllowed"
                      checked={formState.orgUnitAthleteRegistrationAllowed}
                      disabled={true} />
                  </div>
                </div>
                <div className={formState.orgUnitAthleteRegistrationAllowed === true ? global.DisplayComponent : global.HideComponent}>
                  <div className="row">
                    <div className="col-xs-12 col-sm-6 col-md-4">
                      <ReadOnly
                        label="Athlete Entry Start Date"
                        name="orgUnitRegistrationStartDate"
                        value={formatDateTimeTwelveHourClock(omeMeetOrgUnitEntryRosterPermissionsState.objData.orgUnitRegistrationStartDate)} />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-4">
                      <ReadOnly
                        label="Athlete Entry End Date"
                        name="orgUnitRegistrationEndDate"
                        value={formatDateTimeTwelveHourClock(omeMeetOrgUnitEntryRosterPermissionsState.objData.orgUnitRegistrationEndDate)} />
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-4">
                      <ReadOnly
                        label="Time Zone"
                        name="timeZone"
                        value={formState.timeZone} />
                    </div>
                  </div>
                </div>
                <div className="row usas-extra-top-margin">
                  <div className="col-xs-12">
                    <OrgUnitAdminContactsReadOnly />
                  </div>
                </div>
              </Fragment>
            }
          </Fragment>
        }
        <PopUpModal
          widthPct={30}
          maxWidth={250}
          title={Constants.LOADING_MSG}
          displayPopUp={omeMeetOrgUnitEntryState.isObjLoading || omeMeetOrgUnitEntryInfoState.isObjLoading || omeMeetOrgUnitAthleteEntryState.isArrayLoading ||
            omeMeetOrgUnitAthleteEntryRelayRosterEntryState.isArrayLoading || omeMeetOrgUnitNonAthleteEntryState.isArrayLoading || omeMeetOrgUnitContactState.isArrayLoading ||
            omeMeetOrgUnitEntryRosterPermissionsState.isObjLoading || dateTimeState.isObjLoading} />
        <PopUpModal
          widthPct={30}
          maxWidth={250}
          title={Constants.SAVING_MSG}
          displayPopUp={omeMeetOrgUnitEntryState.isSaving || omeMeetOrgUnitEntryRosterPermissionsState.isSaving} />
        <PopUpModal
          widthPct={90}
          maxWidth={720}
          title={modalState.modalTitle}
          displayPopUp={modalState.displayPopUp}
          onModalCanceled={onModalCanceled}>
          <div className="row">
            <div className="col-xs-12">
              <p><strong>Entry Contact Name:</strong> {modalState?.contactName}</p>
              <p><strong>Email:</strong> {modalState?.emailAddress}</p>
            </div>
            <div className="col-xs-12 usas-extra-top-margin">
              <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>&nbsp;
              <PrimaryButton type="button" onClick={(e) => onDeleteContact(e, modalState.omeMeetOrgUnitContactId)}>Delete</PrimaryButton>
            </div>
          </div>
        </PopUpModal>
      </ViewTemplate>
    </Fragment>
  );
};

export default OrgUnitAdminMeetInfo;